import React, { useState } from 'react';
import { Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import apiProxyService from '../../infrastructure/api/ApiProxyService';
import './AuthLoginPage.css';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) {
      setError('Please enter a valid email address.');
      return;
    }
    setError(null);
    setLoading(true);
    // Always show the same confirmation regardless of whether the email exists,
    // so the form can't be used to probe which emails are registered.
    const res = await apiProxyService.forgotPassword(email.trim());
    setLoading(false);
    if (res.success || res.statusCode === 404) {
      setSent(true);
    } else {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="auth-login-root">
      <div className="alp-right">
        <div className="alp-form-box">
          <div className="alp-form-header">
            <h1 className="alp-form-title">Forgot your password?</h1>
            <p className="alp-form-sub">
              Enter your email and we'll send you a link to reset your password.
            </p>
          </div>

          {sent ? (
            <div className="alp-field" style={{ alignItems: 'center', textAlign: 'center', gap: 12 }}>
              <CheckCircle2 size={40} color="#10B981" />
              <p className="alp-form-sub" style={{ margin: 0 }}>
                If an account exists for <strong>{email.trim()}</strong>, a password reset link is on its way.
                Check your inbox (and spam folder).
              </p>
              <a href="/auth/login" className="alp-btn-submit" style={{ textDecoration: 'none' }}>
                Back to sign in
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              <div className="alp-field">
                <label className="alp-field-label">Email</label>
                <div className="alp-field-wrap">
                  <span className="alp-field-icon">
                    <Mail size={18} />
                  </span>
                  <input
                    type="email"
                    name="email"
                    className="alp-input"
                    placeholder="you@example.com"
                    autoCapitalize="none"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(null); }}
                    required
                  />
                </div>
              </div>

              {error && <div className="alp-err" style={{ marginBottom: 12 }}>{error}</div>}

              <button type="submit" className="alp-btn-submit" disabled={loading}>
                {loading ? (
                  <>
                    <span className="alp-spinner" />
                    Sending…
                  </>
                ) : (
                  'Send reset link'
                )}
              </button>
            </form>
          )}

          <div className="alp-form-footer">
            <a href="/auth/login" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <ArrowLeft size={15} /> Back to sign in
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
